// extracted by mini-css-extract-plugin
module.exports = {"employmentHurdle":"styles-module__employmentHurdle___WMy7X","question":"styles-module__question___1cGHY","expandedDataSection":"styles-module__expandedDataSection___SDe4f"};